<ion-content fullscreen="true">
    <div class="content-container">
        <div class="content">

            <div class="title-1">
                {{line1 | translate}}
            </div>
            <div class="text-1">
                {{line2 | translate}}
            </div>
        </div>

        <ion-footer mode="ios">
            <ion-button expand="full" class="action-btn" (click)="onProceed()"
                >{{btn1Txt | translate}}
            </ion-button>

            <ion-button *ngIf="btn2Txt!==''"
                expand="full"
                fill="outline"
                class="exit-btn"
                (click)="onDismiss()"
                >{{btn2Txt | translate}}
            </ion-button>
           
        </ion-footer>
    </div>
</ion-content>
